export const created = "Создан";
export const approved = "Утвержден";
export const started = "Запущен";
export const problem = "Проблема";
export const failed = "Провален";
export const canceled = "Отменен";
export const completed = "Завершен";
